import React from 'react'

export default props => <h2>Legal Information</h2>
